"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearCta = exports.ctaStyles = void 0;
const colors_1 = require("../basic/colors");
const spaces_1 = require("../basic/spaces");
const radii_1 = require("../basic/radii");
const font_faces_1 = require("./font-faces");
exports.ctaStyles = Object.assign(Object.assign({ backgroundColor: colors_1.colors.primary, borderRadius: radii_1.radii.default }, font_faces_1.FONT_SIZE.BUTTON), { letterSpacing: '0.8px', color: colors_1.baseColors.white, paddingTop: '10px', paddingBottom: '10px', paddingRight: spaces_1.space[4], paddingLeft: spaces_1.space[4], '&:disabled, &[disabled]': {
        backgroundColor: colors_1.colors.lightGreyFirst,
        borderColor: colors_1.colors.lightGreyFirst,
        color: colors_1.colors.secondary,
        cursor: 'default',
        textDecoration: 'none',
    } });
exports.clearCta = {
    border: 'none',
    ':focus:not([disabled]),:hover:not([disabled]),:focus-visible:not([disabled])': {
        backgroundColor: 'initial',
        color: 'inherit',
        borderColor: 'initial',
        border: 'none',
    },
};
//# sourceMappingURL=cta.js.map